import React, { useState } from 'react'
import classNames from 'classnames'
import { func, bool, number } from 'prop-types'
import Icon from 'components/uiElements/Icon'
import Tooltip from 'components/Tooltip'
import { useTranslation } from 'react-i18next'
import Toast from '@ingka/toast'
import './Sweep.scss'

const Sweep = ({
    compositionId,
    removeRenderItems,
    undoRemoveRenderItems,
    hasRenderItems,
    onSweepButtonMouseOut,
    onSweepButtonMouseOver,
}) => {
    const [showSweepToast, setShowSweepToast] = useState(false)
    const { t } = useTranslation()
    return (
        <div className="Sweep">
            <Toast
                text={<>{t('sweep.all pinned items have been removed')}</>}
                isOpen={showSweepToast}
                actionButtonText={t('sweep.undo')}
                actionClick={() => {
                    undoRemoveRenderItems(compositionId)
                    setShowSweepToast(false)
                }} // required if there is an action label supplied
                onCloseRequest={() => {
                    setShowSweepToast(false)
                }}
                onTransitionEnd={() => {}}
                ariaLabelCloseBtn={t('sweep.dismiss notification')}
            />
            <Tooltip id="sweep-btn" hide={!hasRenderItems} />
            <button
                onClick={() => {
                    removeRenderItems(compositionId)
                    setShowSweepToast(true)
                }}
                className={classNames('sweepButton', { enabled: hasRenderItems })}
                disabled={!hasRenderItems}
                onMouseOver={onSweepButtonMouseOver}
                onFocus={onSweepButtonMouseOver}
                onMouseOut={onSweepButtonMouseOut}
                onBlur={onSweepButtonMouseOut}
                data-tip={t('tooltip.remove all items')}
                data-for="sweep-btn"
                data-testid="sweep-btn"
            >
                {hasRenderItems ? <Icon code="sweep" svg /> : <Icon code="sweep_disabled" svg />}
            </button>
        </div>
    )
}

Sweep.propTypes = {
    removeRenderItems: func.isRequired,
    undoRemoveRenderItems: func.isRequired,
    hasRenderItems: bool.isRequired,
    compositionId: number.isRequired,
    onSweepButtonMouseOver: func.isRequired,
    onSweepButtonMouseOut: func.isRequired,
}

export default Sweep
